var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg008Locations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 540 540",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270,13.5c-90.1,0-165.3,72.6-165.3,165.3s10.6,66.7,30.9,96.2l121.7,190c5.9,9.2,19.4,9.2,25.3,0l122.3-190.6c19.9-28.1,30.4-61.2,30.4-95.5,0-91.2-74.2-165.3-165.3-165.3ZM270,254c-41.4,0-75.1-33.7-75.1-75.1s33.7-75.1,75.1-75.1,75.1,33.7,75.1,75.1-33.7,75.1-75.1,75.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M387.5,358.9l-75.7,118.3c-19.6,30.5-64.1,30.4-83.6,0l-75.8-118.3c-66.7,15.4-107.8,43.7-107.8,77.4,0,58.6,116.2,90.2,225.4,90.2s225.4-31.6,225.4-90.2-41.2-62-107.9-77.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg008Locations);
export default __webpack_public_path__ + "static/media/008-locations.3fcc023c466a20d035482cfbb08d9e18.svg";
export { ForwardRef as ReactComponent };